import { jsx as _jsx } from "react/jsx-runtime";
const ImageSet = (props) => {
    const setSelectedIndex = (index) => {
        props.setSelectedIndex(index);
    };
    const getImagesThumbnails = () => {
        return props.images.map((image, index) => {
            return (_jsx("div", { className: `sudoku-images__item ${index === props.selectedIndex - 1 ? 'selected' : ''}`, onClick: () => setSelectedIndex(index + 1), children: _jsx("img", { className: "sudoku-images__img", src: image }) }, index));
        });
    };
    return (_jsx("div", { className: "sudoku-images", children: getImagesThumbnails() }));
};
export default ImageSet;
